// import integrationImg from '../../images/services/integration.jpg';
import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const PostMergerIntegration = () => {
  const serviceData = {
    title: "Post-Merger Integration Assistance",
    heading: "Post-Merger Integration Assistance",
    image: subTopicImages["Post-Merger Integration Assistance"],
    intro:
      "Helping businesses realise value after the deal — not just at signing",
    description: [
      "The real challenge in M&A begins after the transaction closes. Differences in systems, culture, controls and processes can affect performance if not managed well.",
      "We support management teams in integration planning and execution, helping align finance processes, reporting, governance and operational workflows.",
    ],
    services: [
      {
        title: "Our Support Includes",
        list: [
          "integration roadmap & milestone planning",
          "finance & MIS system alignment",
          "internal control harmonisation",
          "policy & SOP convergence",
          "working capital monitoring",
          "post-deal performance review",
          "synergy tracking & reporting",
        ],
        extraInfo: "",
      },
    ],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      projects={serviceData.benefits}
    />
  );
};

export default PostMergerIntegration;
